import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'gender'
})
export class GenderPipe implements PipeTransform {
  transform(value: String): string {
    if (value === 'M') {
      return 'Male';
    } else if (value === 'F') {
      return 'Female';
    } else if (value === 'U') {
      return 'Unknown';
    } else {
      return null;
    }
  }
}
